import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "tags"]

  connect() {
    // Initialize tags from existing hidden inputs (for error states)
    const existingInputs = this.element.querySelectorAll('input[name="convo_message[recipients][]"][value!=""]')
    existingInputs.forEach(input => {
      const recipient = input.value
      if (recipient && !this.tagsTarget.querySelector(`[data-recipient-value="${recipient}"]`)) {
        this.createTag(recipient)
      }
      input.remove() // Remove the initial hidden input, we'll recreate them
    })
    this.updateHiddenInputs()
  }

  handleKeydown(event) {
    if (event.key === "Enter" || event.key === ",") {
      event.preventDefault()
      this.addRecipient()
    } else if (event.key === "Backspace" && this.inputTarget.value === "" && this.tagsTarget.children.length > 0) {
      this.removeLastTag()
    }
  }

  addRecipient() {
    const value = this.inputTarget.value.trim()
    if (value === "") return

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(value)) {
      return
    }

    // Check if already exists
    const existingRecipients = Array.from(this.tagsTarget.children).map(tag => 
      tag.dataset.recipientValue
    )
    if (existingRecipients.includes(value)) {
      this.inputTarget.value = ""
      return
    }

    this.createTag(value)
    this.inputTarget.value = ""
    this.updateHiddenInputs()
  }

  removeRecipient(event) {
    event.preventDefault()
    const tag = event.currentTarget.closest(".recipient-tag")
    if (tag) {
      tag.remove()
      this.updateHiddenInputs()
    }
  }

  removeLastTag() {
    const lastTag = this.tagsTarget.lastElementChild
    if (lastTag) {
      lastTag.remove()
      this.updateHiddenInputs()
    }
  }

  createTag(email) {
    const tag = document.createElement("div")
    tag.className = "recipient-tag"
    tag.dataset.recipientValue = email
    tag.innerHTML = `
      <span>${email}</span>
      <button type="button" class="tag-remove" data-action="click->recipients#removeRecipient">
        <i class="bi bi-x"></i>
      </button>
    `
    this.tagsTarget.appendChild(tag)
  }

  updateHiddenInputs() {
    // Remove all existing hidden inputs with name recipients
    const existingInputs = this.element.querySelectorAll('input[name="convo_message[recipients][]"]')
    existingInputs.forEach(input => {
      input.remove()
    })

    // Add new hidden inputs for each tag
    const recipients = Array.from(this.tagsTarget.children).map(tag => tag.dataset.recipientValue)
    recipients.forEach((recipient) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "convo_message[recipients][]"
      input.value = recipient
      this.element.appendChild(input)
    })
  }
}
